import { render, staticRenderFns } from "./Scope.vue?vue&type=template&id=481a17fc&scoped=true&"
import script from "./Scope.vue?vue&type=script&lang=js&"
export * from "./Scope.vue?vue&type=script&lang=js&"
import style0 from "./Scope.vue?vue&type=style&index=0&id=481a17fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a17fc",
  null
  
)

export default component.exports